<template>
  <div class="material-upload-view" v-loading="loading"
       :class="{'is-doc-upload': !isDocUpload}"
       @dragover.prevent="uploadDragOver">
    <div class="jp-material-upload-content"
         :class="{'is-seal': isSeal && step === '1'}">
      <div class="fd-upload-seal" v-if="isDocUpload">
        <button :class="[!isSeal?'active':'']"
                @click="isSeal=false;step='1'">未签章
        </button>
        <button :class="[isSeal?'active':'']"
                v-if="queryParams.params.channel === 'mediate_mediator'"
                @click="isSeal=true">已签章
        </button>
        <div></div>
      </div>
      <template v-if="isSeal && step === '1'">
        <p class="jp-delivery-tooltip" :class="{'is-dark': effect === 'dark'}">为避免出现程序性错误，系统将自动对您文件名中的隐藏字符进行删除，请您知悉！</p>
        <p class="jp-delivery-tooltip" :class="{'is-dark': effect === 'dark'}">系统将自动对您上传的已经完成线下盖章的文书压缩包进行上传、解压，并在您选中的 <span>{{queryParams.params.total}}个</span> 案件范围内进行自动匹配！</p>
        <!--自动送达确认-->
        <component-delivery-signature-content
          :effect="effect"
          is-upload-module
          @change="changeHandler"/>
      </template>
      <template v-else>
        <p class="jp-delivery-tooltip" :class="{'is-dark': effect === 'dark'}">为避免出现程序性错误，系统将自动对您文件名中的隐藏字符进行删除，请您知悉！</p>
        <div class="fd-upload-select" @dragover.stop.prevent="()=>{}">
          <span>上传方式<span style="color: #ed6104;"></span></span>
          <el-select size="mini" v-model="uploadSelect" style="width: 100%;">
            <el-option label="文件夹上传" v-if="isSingleCase && !isFilterResult" value="2"></el-option>
            <el-option label="文件上传" value="1"></el-option>
          </el-select>
        </div>
        <div class="fd-upload-select" v-if="isDocUpload" @dragover.stop.prevent="()=>{}">
          <span>文件重复<span style="color: #ed6104;"></span></span>
          <div size="mini" v-model="uploadSelect">
            <el-popover
              class="file-cover"
              popper-class="file-radio"
              placement="top"
              width="200"
              trigger="hover"
              :open-delay="500"
              content="上传文件与系统中已有文件重复时，全部覆盖">
              <el-radio slot="reference" class="upload-radio" v-model="uploadRecover" label="0">全部覆盖</el-radio>
            </el-popover>
            <el-popover
              popper-class="file-radio"
              placement="top"
              width="200"
              trigger="hover"
              :open-delay="500"
              content="上传文件与系统中已有文件重复时，全部跳过">
              <el-radio slot="reference" class="upload-radio" v-model="uploadRecover" label="1">全部跳过</el-radio>
            </el-popover>
          </div>
        </div>

        <div class="fd-upload-view" @click.stop="uploadClick" @dragover.stop.prevent="()=>{}">
          <img src="@/assets/image/case-import/ic_upload.png">
          <div class="el-upload__text"><span>点击上传</span></div>
          <el-button class="download-btn" size="mini" @click.stop="exportFile">下载范本</el-button>
          <input style="display: none;" type="file" ref="uploadInput" @change="uploadChange" v-if="isShowUploadInput"
                 @blur="uploadBlur"
                 :multiple="isSingleCase"
                 :webkitdirectory="isSingleCase&&uploadSelect=='2'">
        </div>
      </template>
    </div>
    <div class="jp-material-bottom"
         :class="{'is-dark': effect === 'dark'}"
         v-show="isSeal && step === '1'">
      <el-button type="primary"
                 :disabled="!deliveryFlag"
                 size="medium"
                 @click="step='2'">设置完成，去上传文书
      </el-button>
    </div>
  </div>

</template>

<script>
import MaterialUpload from './materialUpload';
import {getUrlKey} from '@/assets/js/tool';
import {fileOrDirMatch} from '@/assets/js/api';
import ComponentDeliverySignatureContent from '../../case-handling/components/common/delivery-signature-content';
import {mapState} from 'vuex';

export default {
  name: 'material-upload-view',
  components: {ComponentDeliverySignatureContent},
  props: {
    isSingleCase: {// 是否只选择一个案子
      type: Boolean,
      default: false,
    },
    //* 单个案件材料批量上传必要参数
    mediateId: {
      type: String,
      default: '',
    },
    isDocUpload: {
      type: Boolean,
      default: false,
    },
    // 列表批量上传必要参数
    queryParams: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 主题 light / dark
    effect: {
      type: String,
      default: 'light'
    }
    // 渠道，brt:保融通，mediate_admin_upload:调解管理人上传，mediate_mediator：调解员
    // channel: {
    //   type: String,
    //   default: ''
    // }
  },
  data() {
    return {
      isSeal: false,
      currentMediateId: '', // 单个案件材料批量上传必要参数
      loading: false,
      showLayer: false,
      materialUpload: null,
      uploadSelect: '1',
      uploadRecover: '1', // 选择全部覆盖或者跳过，默认跳过
      isShowUploadInput: true,
      // 当前需要送达的文书类型
      detailType: [],
      // 是否自动送达文书
      deliveryFlag: '',
      // 当前位于已签章第几步
      step: '1'
    };
  },
  watch: {
    isSeal(n) {
      if (!n) {
        // 初始化
        this.deliveryFlag = '';
        this.detailType = [];
      }
    }
  },
  computed: {
    ...mapState({userData: state => state.user.userData}),
    // 是否代理人端使用
    //  这里获取不到this.$route，所以使用这个方法来获取url中的system
    isAgentRule() {
      // 获取url中的参数
      const system = getUrlKey('system', window.location.href);
      return system && system.indexOf('brt') > -1 || JSON.parse(sessionStorage.getItem('vuex')).user.activeRoleName === '案件管理员';
    },
    exportFileType() {
      // 材料
      let type = 'brt';
      if (window.location.href.indexOf('sfqr') > -1 || window.location.href.indexOf('brt-judicial-confirmation-detail') > -1) {
        // 司法确认
        type = 'judicial';
      } else if (this.isDocUpload) {
        // 文书
        type = 'offline';
      }
      return {type, caseChannel: this.queryParams.params.caseChannel || ''};
    },
    isFilterResult(){
      return this.queryParams.params && this.queryParams.params.isFilterResult
    }
  },
  methods: {
    exportFile() {
      // 调解员使用 offline，代理人使用 brt
      this.$api.downLoadBatchUploadTemp(this.exportFileType)
        .then(res => {
          if (res && res.code == 200 && res.data) {
            this.$utils.downloadFile(res.data);
          }
        }, err => {

        });
    },

    /**
     *拖拽上传
     */
    uploadDragOver(e) {
      if (!this.showLayer) {
        this.showLayer = true;
      }
      console.log('uploadDragOver', e);
    },

    /**
     * 点击上传(文件／文件夹)
     */
    uploadClick(e) {
      this.$refs.uploadInput.click();
    },

    uploadBlur(e) {
      console.log('uploadBlur', e);
    },
    // 压缩包
    checkZipStandard(uploadFile) {
      console.log('uploadFile', uploadFile);
      this.startUpload([uploadFile]);
      this.materialUpload.checkZipStandard(
        uploadFile,
        // 执行上传和匹配任务操作
        fileEntry =>
          this.materialUpload.upload(
            fileEntry,
            this.zipUploadTask,
            this.progress,
            {}),
        this.$message.warning);
    },
    // 单文件
    upload(uploadFile) {
      console.log('uploadFile', uploadFile);
      // 直接上传
      this.startUpload([uploadFile]);
      this.materialUpload.upload(
        uploadFile,
        this.zipUploadTask,
        this.progress,
        {}
      );
    },
    // 多文件
    uploadFiles(files) {
      // 需要全部上传
      const uploadFiles = [];
      for (const key of Object.keys(files)) {
        uploadFiles.push(files[key]);
      }
      if (uploadFiles.length > 0) {
        console.log('uploadFile', uploadFiles);
        this.startUpload(uploadFiles);
        this.materialUpload.uploadFiles(
          uploadFiles,
          this.progress,
          this.fileOrDirUploadTask,
          () => {},
          true);
      } else {
        this.$message.warning('没有符合上传要求的文件');
      }
    },
    startUpload(uploadFiles) {
      const size = uploadFiles.reduce((result, current) => {
        return result += current.size;
      }, 0);
      this.$store.dispatch('SetLogData', {
        log: {
          uid: this.userData.uid,
          batchid: this.queryParams.params.batchId
        },
        map: {
          st: new Date().getTime(),
          size,
          cnt: uploadFiles.length
        }
      });
    },
    async uploadChange(e) {
      const task = await this.$api.getCurrentFileMatchTask();
      if (task.data) {
        return this.$message.error('当前有任务正在执行，不允许重复创建任务');
      }
      this.$bus.$emit('uploadChange');
      if (!this.materialUpload) {
        this.materialUpload = new MaterialUpload();
      }
      let files = e.target.files;
      console.log('uploadChange', e);
      // 文件／文件夹
      if (files.length > 500) {
        this.$message.warning('单个案件最多支持前500个文件上传匹配');
        // 截取500文件上传
        files = files.slice(0, 499);
      }
      // zip
      if (!this.isSingleCase) {
        return this.checkZipStandard(files[0]);
      }

      // 检查有没有zip
      let canUploadFiles = true;
      for (let i = 0; i < files.length; i++) {
        if (this.getSuffix(files[i].name) === 'zip') {
          this.upload(files[i]);
          canUploadFiles = false;
          break;
        }
      }

      if (canUploadFiles) {
        this.uploadFiles(files);
      }
    },
    getSuffix(str) {
      const suffix = str.split('.')
        .reverse()[0];
      return suffix;
    },
    progress(progress) {
      return this.$emit('uploadProgress', progress);
    },
    createTaskParams(successList, errList) {
      const params = {
        fileList: [],
        errorList: [],
        mediateId: this.mediateId,
        channel: this.queryParams.params.channel,
        isSignatureType: this.isSeal,
        isOverride: this.isDocUpload ? this.uploadRecover == '0' : this.queryParams.params.isOverride,
        uploadType: this.isDocUpload ? 1 : 0,
        actId: this.queryParams.params.actId,
        batchId: this.queryParams.params.batchId,
        // 上传完是否自动送达
        deliveryFlag: this.deliveryFlag === '1',
        // 送达文书类型
        detailType: this.detailType
      };
      if (successList) {
        successList.forEach(item => {
          params.fileList.push({
            'absolutePath': item.absolutePath,
            'fileName': item.fileName,
            'fileSize': item.fileSize,
            'saveId': item.saveId,
          });
        });
      }

      if (errList) {
        errList.forEach(item => {
          params.errorList.push(item);
        });
      }
      return params;
    },

    /**
     * 文件夹／文件匹配上传任务-只有单个案件
     * @param uploadSuccessList
     * @param uploadErrList
     * @param msg
     */
    fileOrDirUploadTask(uploadSuccessList, uploadErrList, msg) {
      console.log('uploadChange-fileList', uploadSuccessList, uploadErrList, msg);
      // 文件／文件夹任务开启
      this.$emit('fileMatchRate', {showRate: true, result: false, taskId: '', msg: '没有符合上传要求的文件'});
      const timer = setTimeout(async () => {
        const fileMatchRateParams = {
          code: 200,
          result: false,
          taskId: '',
          msg: '没有符合上传要求的文件'
        };
        if (uploadSuccessList.length > 0) {
          const params = this.createTaskParams(uploadSuccessList, uploadErrList);
          const {
            code, data, msg
          } = await fileOrDirMatch(params, true)
            .finally(() => {
              this.createTaskParams();
            });

          fileMatchRateParams.code = code;
          if (code === 200 && data) {
            fileMatchRateParams.result = true;
            fileMatchRateParams.taskId = data;
          } else {
            fileMatchRateParams.msg = msg;
          }
        }
        this.$emit('fileMatchRate', fileMatchRateParams);
        clearTimeout(timer);
      }, 1000);
    },


    createZipTaskParams(fileId) {
      console.log('createZipTaskParams', this.queryParams);
      const params = this.queryParams.params ? this.queryParams.params : {};
      params.uploadType = this.isDocUpload ? 1 : 0;
      params.isSignatureType = this.isSeal;
      params.fileId = fileId;
      params.isOverride = this.isDocUpload ? this.uploadRecover == '0' : this.queryParams.params.isOverride;
      // 是否自动送达
      params.deliveryFlag = this.deliveryFlag === '1';
      // 自动送达文书
      params.detailType = this.detailType || [];
      return params;
    },


    /**
     * zip包匹配任务
     */
    async zipUploadTask(res) {
      const fileMatchRateParams = {
        result: false,
        taskId: '',
      };
      if (res.code === 200) {
        const params = this.createZipTaskParams(res.data.fileId);
        const {
          code, data
        } = await this.$api.zipFileMatch(params);
        if (code === 200 && data) {
          fileMatchRateParams.result = true;
          fileMatchRateParams.taskId = data;
        }
      }
      this.$emit('fileMatchRate', fileMatchRateParams);
    },

    cancel() {
      if (this.materialUpload) {
        this.materialUpload.cancel();
      }
    },
    clearFile() {
      this.isShowUploadInput = false;
      this.$nextTick(() => {
        this.isShowUploadInput = true;
      });
    },
    // 已签章-自动送达设置
    changeHandler(data) {
      const {
        detailType, deliveryFlag
      } = data;
      this.deliveryFlag = deliveryFlag;
      this.detailType = detailType;
    },
    // 点击下一步触发
    clickNextStep() {
      this.step = '2';
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.material-upload-view {
  display: flex;
  flex-direction: column;
  background: #fff;
}

.jp-material-upload-content {
  padding: 24px 40px 40px;
  width: 100%;

  &.is-seal {
    padding-bottom: 32px;
  }
}

.is-doc-upload {
  max-height: 360px;
}

.fd-upload-view {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  padding: 62px 0;
  width: 100%;
  max-height: 256px;
  border-radius: 2px;
  border: 1px solid #eee;
  cursor: pointer;

  > img {
    width: 48px;
    height: 53px;
  }

  .el-upload__text {
    margin-top: 5px;
    color: #999;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    line-height: 14px;

    > span {
      color: #274ea4;
    }
  }

  .download-btn {
    margin-top: 24px;
    width: 216px;
    height: 36px;
    border-radius: 2px;
    border: 1px solid #eee;
  }
}

.fd-upload-select {
  display: flex;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;

  > span {
    margin-right: 48px;
    color: #999;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    line-height: 14px;
    white-space: pre;
  }
}

.fd-upload-seal {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  margin-bottom: 16px;

  > button {
    width: 105px;
    height: 40px;
    color: #999;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 20px;
    border: 1px solid #eee;
    background: #f7f8fa;
    cursor: pointer;
  }

  > button:active {
    background: rgba(238, 238, 238, 0.8);
  }

  .active {
    color: #323233;
    border: 1px solid #eee;
    border-bottom: 0;
    background: #fff;
  }

  > div {
    flex: 1;
    width: 287px;
    height: 1px;
    background: #eee;
  }
}

.fd-drag-layer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  color: #fff;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  line-height: 24px;
  background: rgba(0, 0, 0, 0.64);
  cursor: default;
}

.upload-radio {
  color: #333;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 14px;

  .el-radio__label {
  }
}

.file-cover {
  margin-right: 20px;
}

.jp-material-bottom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 40px;
  height: 68px;
  border-radius: 0 0 4px 4px;
  border-top: 1px solid #eee;

  &.is-dark {
    border-top: 1px solid #404040;
  }

  .el-button {
    min-width: 128px;
  }
}
.jp-delivery-tooltip {
  margin-bottom: 12px;
  font-size: 14px;
  color: #333;
  line-height: 21px;
  user-select: none;
  word-break: keep-all;
  &.is-dark {
    color: #fff;
  }
  span {
    color: #E28103;
    font-weight: bold;
  }
}
</style>
